import api from 'api/api';
import authApi from 'api/authApi';
import addressApi from 'api/addressApi';

export { authApi, addressApi };
export default api;
